import { getPrivacyPolicyContent } from "api/rental-agreement/rental-agreement";
import { globalJson } from "global/global_json";
import React, { useEffect, useState } from "react";
import { sanitizeHtml } from "utils/sanitizeHtml";

function PrivacyPolicy() {
  const [content, setContent] = useState([]); // Ensure content is always an array
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getContent = async () => {
      setLoading(true);
      try {
        const response = await getPrivacyPolicyContent(
          process.env.REACT_APP_ENV !== "prod"
            ? globalJson.dev_company_id
            : globalJson.prod_company_id
        );

        // Ensure data is an array or default to an empty array
        setContent(response.data.privacy_policy);
      } catch (error) {
        console.error("Error fetching content", error);
      } finally {
        setLoading(false);
      }
    };

    getContent();
  }, []);

  return (
    <div className="mt-6 rounded-lg border bg-white p-4 min-h-[60vh]">
      <div className="mb-8">
        <h1 className="text-lg font-bold text-[#00283E]">Privacy Policy</h1>
      </div>
      {loading ? (
        <div className="flex justify-center items-center col-span-full min-h-[40vh]">
          <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-neutral-200"></div>
        </div>
      ) : (
        <div className="col-span-12 @container">
          <div className="flex flex-col gap-y-4">
            {content?.length > 0 ? (
              content?.map((item: any, i: number) => (
                <div className="rounded-lg border border-muted" key={i}>
                  <div className="header rounded-lg bg-[#f7f7f7] px-5 py-3">
                    <h4 className="text-lg">
                      {i + 1}. {item?.title}
                    </h4>
                  </div>
                  <div className="header border-t border-muted p-5 w-full">
                    <div className="grid grid-cols-1 gap-3 rounded-lg w-full">
                      <div
                        className="prose prose-sm text-gray-500 break-words"
                        style={{ maxWidth: "100%" }}
                        dangerouslySetInnerHTML={{
                          __html: sanitizeHtml(item?.content),
                        }}
                      />
                    </div>
                  </div>
                  {item?.content_picture &&
                    item?.content_picture !== "null" && (
                      <div className="header border-t border-muted p-5">
                        <div className="grid grid-cols-1 gap-3 rounded-lg">
                          <img
                            alt="privacy policy"
                            src={`https://fleet-management-images-upload-be.s3.amazonaws.com/${item?.content_picture}`}
                            height={660}
                            width={600}
                            className="w-full rounded-lg"
                          />
                        </div>
                      </div>
                    )}
                </div>
              ))
            ) : (
              <p>No content available.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default PrivacyPolicy;
